import { Injectable } from '@angular/core';
import { appConfig } from '../app.config';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import { Group, PersonById, Role } from './models/ArcaModel';

@Injectable({
  providedIn: 'root'
})
export class ArcaService {
  apiUrl = '';
  constructor(private apiService: CommonService) {
  this.apiUrl=appConfig.ArcaServiceUrl;
   }

  getPerson(url):Observable<PersonById> {
    return this.apiService.getServiceCall(`${this.apiUrl}/get-Person`, url) as Observable<PersonById>;
  }
  getgroup(url):Observable<Group> {
    return this.apiService.getServiceCall(`${this.apiUrl}/get-Group`, url) as Observable<Group>;
  }
  getrole(url):Observable<Role> {
    return this.apiService.getServiceCall(`${this.apiUrl}/get-Role`, url) as Observable<Role>;
  }
}
